import { render } from "./inbox.vue?vue&type=template&id=c78b3b78&ts=true"
import script from "./inbox.vue?vue&type=script&lang=ts"
export * from "./inbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__